@if (pdfVoucher) {
<pdf-voucher-template [data]="pdfVoucher" [color]="color" [voucherData]="voucherData!" />
}
